<template>
  <div class="container-fluid calendar-page-wrapper">
    <div class="row">
      <div class="col-md-12">
        <div class="section">
          <div class="section-header">
              <div class="calendar-header-label">
                <button
                  class="btn btn-transparent-bkg"
                  @click.prevent="prevPeriodSelected">
                  <img src="@/assets/images/icons/arrow-left-icon.png" alt="left">
                </button>
                <button
                  class="btn btn-transparent-bkg btn-next"
                  @click.prevent="nextPeriodSelected">
                  <img src="@/assets/images/icons/arrow-left-icon.png" alt="left">
                </button>
                <h4 class="header-label">{{ calendarTitle }}</h4>
              </div>
              <div class="dropdown responsive-filter-dropdown fa-pull-right" :class="{'open': isResponsiveDropdownOpened }">
                <a class="btn btn-transparent-bkg btn-white-text btn-no-border bold ng-scope" role="button" id="dropdownMenuLink" @click="isResponsiveDropdownOpened = !isResponsiveDropdownOpened">
                    <img src="@/assets/images/icons/filter-icon.png" alt="filter icon">
                    {{$t('CALENDAR.filters')}}
                </a>

                <div class="dropdown-menu filter-dropdown">
                  <CalendarFilter
                    :previewMode="calendarPreviewMode"
                    :view-date="viewDate"
                    :title="viewDate"
                    :selectedSessionTypes="selectedSessionTypes"
                    :onViewDateChange="viewDateChange"
                    :onCalendarPreviewChange="calendarPreviewChange"
                    :onSessionTypeFilterChange="calendarSessionTypeChange"
                    :calendar-teams="calendarTeams"
                    :change-selected-teams="changeSelectedTeams"
                    :calendar-selected-teams="calendarSelectedTeams"
                    :calendar-teams-fetched="calendarTeamsFetched"
                    :responsive="true" />
                </div>
            </div>
          </div>
          <div class="section-content">
            <CalendarFilter
              :previewMode="calendarPreviewMode"
              :view-date="viewDate"
              :title="viewDate"
              :selectedSessionTypes="selectedSessionTypes"
              :onViewDateChange="viewDateChange"
              :onCalendarPreviewChange="calendarPreviewChange"
              :onSessionTypeFilterChange="calendarSessionTypeChange"
              :change-selected-teams="changeSelectedTeams"
              :calendar-selected-teams="calendarSelectedTeams"
              :calendar-teams="calendarTeams"
              :calendar-teams-fetched="calendarTeamsFetched" />

            <div class="calendar-wrapper">
              <Calendar
                :previewMode="calendarPreviewMode"
                :events="calendarEvents"
                :view-date="viewDate"
                :onPeriodChange="onCalendarPeriodChange"
                :account="account"
                :is-expanded="isExpanded"
                :on-expanded-box-change="onExpandedBoxChange" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { TOASTER_ERROR } from '@/common/events.types'
import {
  FETCH_CALENDAR_DATA,
  CHANGE_LIST_OF_SELECTED_CALENDAR_TEAMS,
  UPLOAD_ACTIVITY_ATTACHMENT,
  UPDATE_CALENDAR_STORAGE,
  UPDATE_PREVIEW_MODE,
  FETCH_FILTER_DATA_FROM_STORAGE,
  UPDATE_VIEW_DATE,
  RESET_STATE
} from '@/store/action.types'
import { API_DATE_FORMAT } from '@/constants/DateConstants'
import Calendar from '@/components/common/calendar/Calendar'
import CalendarFilter from '@/components/common/calendar/CalendarFilter'
import { CALENDAR_VIEW_MODES } from '@/constants/CalendarConsts'
import { SESSION_TYPES, ACTIVITY_STATUS } from '@/constants/SessionConsts'
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'

export default {
  name: 'CalendarContainer',
  data () {
    return {
      isResponsiveDropdownOpened: false,
      isExpanded: undefined
    }
  },
  computed: {
    ...mapGetters([
      'viewDate',
      'events',
      'selectedSessionTypes',
      'account',
      'calendarTeams',
      'calendarSelectedTeams',
      'calendarPreviewMode',
      'calendarTeamsFetched'
    ]),
    calendarTitle () {
      if (this.calendarPreviewMode === CALENDAR_VIEW_MODES.MONTH) {
        return moment(this.viewDate).locale(this.$i18n.locale).format('MMMM YYYY')
      } else {
        return `WEEK ${moment(this.viewDate).week()} OF ${moment(this.viewDate).format('YYYY')}`
      }
    },
    calendarEvents () {
      let calendarEvents = []
      

      this.events.forEach(event => {
        const dateString = event.started;
        const dateSplitted = dateString.split(/[^0-9]/);
        const eventDate = new Date(dateSplitted[0], dateSplitted[1]-1,dateSplitted[2],dateSplitted[3],dateSplitted[4],dateSplitted[5]);
        const context = this;
        
        calendarEvents.push({
          title: `${event.name} - ${Math.ceil((event.durationInSeconds) / 60)} min`,
          routerLink: { name: 'CalendarActivity', params: { activityId: event.playerActivityId } },
          invalidTooltipMessage: (function () {
            switch (event.activityStatus) {
              case ACTIVITY_STATUS.INVALID:
                return `${context.$t('CALENDAR.invalidTooltipMessages.invalid')} <a href="javascript:ZohoHCAsap.kbArticles.view( { articleId : '316220000000446307' } );" title="See article">${context.$t('CALENDAR.invalidTooltipMessages.seeArticle')}</a>`
              case ACTIVITY_STATUS.NOT_SYNCED:
                if (event.type === "INDIVIDUAL") {
                  return context.$t('CALENDAR.invalidTooltipMessages.notSyncedPMA');
                } else {
                  return context.$t('CALENDAR.invalidTooltipMessages.notSyncedCMA');
                }
                // return context.$t('CALENDAR.invalidTooltipMessages.notSynced');
              case ACTIVITY_STATUS.NOT_PROCESSED:
                return context.$t('CALENDAR.invalidTooltipMessages.notProcessed');
              case ACTIVITY_STATUS.FAILED:
                return context.$t('CALENDAR.invalidTooltipMessages.failed');
              case ACTIVITY_STATUS.BELT_NOT_WORN:
                return context.$t('CALENDAR.invalidTooltipMessages.notWorn');
              case ACTIVITY_STATUS.TOO_LONG:
                return context.$t('CALENDAR.invalidTooltipMessages.tooLong');
              default:
                return false
            }
          })(),
          invalidTooltipIcon: (function () {
            switch (event.activityStatus) {
              case ACTIVITY_STATUS.INVALID:
                return 'fas fa-exclamation-triangle pulse mr-3px'
              case ACTIVITY_STATUS.NOT_SYNCED:
                return 'fas fa-unlink mr-3px'
              case ACTIVITY_STATUS.NOT_PROCESSED:
                return 'fas fa-sync mr-3px'
              case ACTIVITY_STATUS.FAILED:
                return 'fas fa-exclamation-circle mr-3px'
              case ACTIVITY_STATUS.BELT_NOT_WORN:
                return 'fas fa-user-times mr-3px'
              default:
                return false
            }
          })(),
          eventId: event.playerActivityId,
          labelColor: (function () {
            switch (event.type) {
              case SESSION_TYPES.GAME:
                return 'red'
              case SESSION_TYPES.TRAINING:
                return 'green'
              case SESSION_TYPES.OTHER:
                return 'purple'
              case SESSION_TYPES.INDIVIDUAL:
                return 'neutral'
            }
          })(),
          started: new Date(eventDate.getFullYear(), eventDate.getMonth(), eventDate.getDate()),
          status: event.activityStatus
        })
      })

      return calendarEvents
    }
  },
  methods: {
    ...mapActions({
      fetchCalendarData: FETCH_CALENDAR_DATA,
      changeSelectedTeams: CHANGE_LIST_OF_SELECTED_CALENDAR_TEAMS,
      uploadAttachment: UPLOAD_ACTIVITY_ATTACHMENT,
      updateCalendarStorage: UPDATE_CALENDAR_STORAGE,
      updatePreviewMode: UPDATE_PREVIEW_MODE,
      fetchFilterDataFromStorage: FETCH_FILTER_DATA_FROM_STORAGE,
      updateViewDate: UPDATE_VIEW_DATE,
      resetState: RESET_STATE
    }),
   
    calendarPreviewChange (previewMode) {
      this.updatePreviewMode(previewMode)
    },
    viewDateChange (newViewDate) {
      this.updateViewDate(newViewDate)
    },
    onCalendarPeriodChange (dates) {
      const playerId = this.account.playerId
      const payload = {}
      payload.startDate = moment(dates.startDate).format(API_DATE_FORMAT)
      payload.endDate = moment(dates.endDate).format(API_DATE_FORMAT)

      if (this.calendarTeams) {
        payload.teams = true
      }

      this.fetchCalendarData({ payload, playerId })
        .catch(() => {
          this.$eventHub.$emit(TOASTER_ERROR, { message: this.$t('TOAST_MESSAGES.errorTryAgain') })
        })
    },
    calendarSessionTypeChange (sessionTypes) {
      this.calendarEvents = this.events.filter(event => sessionTypes.indexOf(event.type) >= 0)
    },
    prevPeriodSelected () {
      this.onExpandedBoxChange()

      if (this.calendarPreviewMode === CALENDAR_VIEW_MODES.MONTH) {
        this.viewDateChange(new Date(this.viewDate.getFullYear(), this.viewDate.getMonth() - 1, 1))
      } else {
        const startOfPrevWeek = moment(this.viewDate).startOf('week').subtract(6, 'days').toDate()
        this.viewDateChange(startOfPrevWeek)
      }
    },
    nextPeriodSelected () {
      this.onExpandedBoxChange()

      if (this.calendarPreviewMode === CALENDAR_VIEW_MODES.MONTH) {
        this.viewDateChange(new Date(this.viewDate.getFullYear(), this.viewDate.getMonth() + 1, 1))
      } else {
        const startOfNextWeek = moment(this.viewDate).startOf('week').add(7, 'days').toDate()
        this.viewDateChange(startOfNextWeek)
      }
    },
    onExpandedBoxChange (id) {
      this.isExpanded = id
    }
  },
  beforeRouteEnter (to, from, next) {
    if (from.name === 'CalendarActivity') {
      next(vm => {
        vm.fetchFilterDataFromStorage()
      })
    } else {
      next(vm => {
        vm.resetState()
      })
    }
  },
  destroyed () { 
    this.updateCalendarStorage()
  },
  components: {
    Calendar,
    CalendarFilter
  }
}
</script>

<style lang="scss">
  .responsive-filter-dropdown {
    display: none;
  }

  .calendar-header-label {
    display: inline-block;
    position: relative;
    left: -10px;
    font-weight: bold;
    color: $white;

    .btn {
        float: left;
        margin-top: 2px;

        &:focus {
          box-shadow: none;
        }
    }

    .header-label {
        float: left;
        text-transform: uppercase;
        font-size: 18px;
        margin-left: 5px;
        margin-right: 5px;
        margin-top: 11px;
    }
  }
</style>
